// @flow

import Api from './ApiBase';

class StudiesApi extends Api {
  fetch = async () => {
    const json = await this.request('studies?page[limit]=100');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new StudiesApi();
